import { AUS_STATES_OPTIONS } from '@ordermentum/ui-constants';

export const initialState = {
  showOther: false,
  errors: {
    first_name: '',
    last_name: '',
    email: '',
    company: '',
    business_type: '',
    business_type_other: '',
  },
  touched: {
    first_name: false,
    last_name: false,
    email: false,
    company: false,
    business_type: false,
    business_type_other: false,
  },
  formData: {
    first_name: '',
    last_name: '',
    email: '',
    phone: '',
    company: '',
    customer_total: '',
    weekly_order_total: '',
    business_type: '',
    business_type_other: '',
    accounting_software: '',
    referral: '',
    campaign: 'Unknown',
  },
};

export const ACCOUNTING_SOFTWARE_OPTION = [
  { display: '---', tag: '' },
  { display: 'Xero', tag: 'Xero' },
  { display: 'MYOB', tag: 'MYOB' },
  { display: 'Netsuite', tag: 'Netsuite' },
  { display: 'Unleashed', tag: 'Unleashed' },
  { display: 'Reckon', tag: 'Reckon' },
  { display: 'Other', tag: 'Other' },
  { display: "I don't use one", tag: "I don't use one" },
  {
    display: 'I prefer not to say',
    tag: 'I prefer not to say',
  },
];

export const BUSINESS_TYPE_OPTIONS = [
  {
    id: '',
    display: '---',
    tag: '',
  },
  {
    id: 'Bread & Pastry Wholesale',
    display: 'Bakery',
    tag: 'Bread & Pastry Wholesale',
  },
  {
    id: 'Coffee Roaster',
    display: 'Coffee Roaster',
    tag: 'Coffee Roaster',
  },
  {
    id: 'Dairy',
    display: 'Dairy',
    tag: 'Dairy',
  },
  {
    id: 'Fruit & Veg',
    display: 'Fruit & Veg',
    tag: 'Fruit & Veg',
  },
  {
    id: 'Meat & Seafood',
    display: 'Meat & Seafood',
    tag: 'Meat & Seafood',
  },
  {
    id: 'Distributor',
    display: 'Foodservice Distributor',
    tag: 'Distributor',
  },
  {
    id: 'Alcohol',
    display: 'Alcohol',
    tag: 'Alcohol',
  },
  {
    id: 'Drinks',
    display: 'Drinks',
    tag: 'Non-Alcoholic Beverages',
  },
  {
    id: 'Packaging',
    display: 'Packaging',
    tag: 'Packaging',
  },
  {
    id: 'Other',
    display: 'Other',
    tag: 'Other',
  },
  {
    id: 'Cafe / Restaurant',
    display: 'Cafe / Restaurant / Venue',
    tag: 'Cafe / Restaurant',
  },
  {
    id: 'Not in the Food and Beverage Industry',
    display: 'Not in the Food & Beverage Industry',
    tag: 'Not in the Food and Beverage Industry',
  },
];

export const REFERRAL_OPTIONS = [
  { display: '---', tag: '' },
  { display: 'Referral from Venue', tag: 'Referral from Venue' },
  { display: 'Referral from Wholesaler', tag: 'Referral from Wholesaler' },
  { display: 'Google Search', tag: 'Google Search' },
  { display: 'Social Media', tag: 'Social Media' },
  {
    display: 'Event/Trade Shows',
    tag: 'Event/Trade Shows',
  },
  {
    display: "We've contacted you previously",
    tag: "We've contacted you previously",
  },
];

export const STATES_OPTIONS = [
  { display: '---', value: '', tag: '' },
  ...AUS_STATES_OPTIONS.map(s => ({ ...s, tag: s.value })),
];
